import { createTranslations } from '@npco/utils-translations'

export const navButtonsTranslations = createTranslations({
  previousLabel: 'Go to previous',
  nextLabel: 'Go to next',
})
